import {
  CsrdCompanyInputSet,
  CsrdTailoringSet,
} from '@upright/common/model/output/materiality/custom-company-input-data/types';
import { DataSourcePublic } from '../../data-sources/types';
import { EuAssessment } from '../../eu-taxonomy/types';
import { PaiAssessment } from '../../pai-assessments/types';
import { CompanyProductSet } from '../products/types';
import { CompanyEmployeeCount } from './employee-counts/types';
import { CompanyIncome } from './incomes/types';
import { CompanyRevenue } from './revenues/types';
import { CompanyFinancialStatement } from '../../financial-statements/types';
import { ConfigurableParametersForEntity } from '@upright/common/model/output/materiality/financial-effects/api-types';
import { PublishedGeolocationSummary } from '../geolocation';

export interface DataPointCommon {
  id: number;
  isInactive: boolean;
  year: number;
  source: string;
  sourceObject?: DataSourcePublic; // UI uses this to display the source name.
  sourceURL?: string;
  trace: DataPointTrace;
  yearIsScrapeYear?: boolean;
}

export type DataPointWithNullableYear = Omit<DataPointCommon, 'year'> & { year: number | null };

export enum DataPointTrace {
  AUTOMATIC = 'AUTOMATIC',
  AUTOMATIC_FUZZY = 'AUTOMATIC_FUZZY',
  MANUAL_UI = 'MANUAL_UI',
  MANUAL_IMPORT = 'MANUAL_IMPORT',
  MANUAL_UNKNOWN = 'MANUAL_UNKNOWN',
  // Datapoint applied from the agentic chat upload flow (PLT-5088), after explicit human
  // sign-off on a proposed batch. Distinguishes agent-applied datapoints from the manual
  // form (MANUAL_UI) so the form can surface a "source: agent" indicator.
  CHAT_AGENT = 'CHAT_AGENT',
}
export const automaticDataPointImportTraces = [DataPointTrace.AUTOMATIC, DataPointTrace.AUTOMATIC_FUZZY];
export function isAutomaticDataPointImportTrace(trace: DataPointTrace) {
  return automaticDataPointImportTraces.includes(trace);
}

export interface WithCompanyId {
  companyId: string;
}

export interface WithReadableBy {
  readableBy: number | undefined;
}

export interface WithSource {
  source: string;
}

export interface CompanyDatapoints {
  productSets: Array<CompanyProductSet & WithCompanyId>;
  revenues: CompanyRevenue[];
  employeeCounts: CompanyEmployeeCount[];
  incomes: CompanyIncome[];
  eutAssessments: EuAssessment[];
  nfrdAssessments: EuAssessment[];
  paiAssessments: PaiAssessment[];
  csrdInputSets: CsrdCompanyInputSet[];
  csrdFeParameters: ConfigurableParametersForEntity[];
  companyFinancialStatements: Array<
    Omit<CompanyFinancialStatement, 'balanceSheet' | 'cashFlowStatement' | 'incomeStatement'>
  >;
  csrdTailoringSets: CsrdTailoringSet[];
  companyGeolocations: PublishedGeolocationSummary[];
}
